export default __webpack_public_path__ + "static/media/no-party.fe0632b8.png";